import { configureStore } from '@reduxjs/toolkit';
import trackingReducer from './Tracking/tracking';

const store = configureStore({
  reducer: {
    tracking: trackingReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
